<template>
  <div class="discoverSection">
    <div class="tinter"></div>
    <section class="discoverContainer">
      <div class="discoverProjects">
        <h1>Our Projects</h1>
        <p>Highground's suite of products utilizes our years of experience in Artificial intelligence, Machine Learning and Natural language Processing (NLP) to advance the capacity and capability of a range of clients</p>
      </div>
      <div class="discoverEvntl">
        <img :src="image" alt="Evntl-Logo">
        <p>Over the past decade, EVNTL's engineers and programmers have developed a proprietary algorithm that can identify, authenticate, geo-locate and deliver intelligence relative to fast breaking events, on a local, regional, national and international scale.</p>
        <p>Our product exploit its unique natural language processing capability, embedded within the broader, proprietary AI platform, to identify, locate and ensure the truth and veracity of a range of events, Our algorithm ensures that the information comes from trusted sources, located in the geographic vicinity of the event in question EVNTL's Critical Event Notification System (CENS) is a unique, real-time event identification ststem. While some vendors offer breaking news services, none utilize the immese power and capacity of Artificial Intelligence to scour, read, interpret and analyze an all-source amalgam of information.</p>
        <p>Whether a man-made or natural event, EVNTL's CENS system is able to assess millions of data sources, in real time, and deliver timely, accurate and verified intelligence to EVNTL's clients. Information pertaining to any event, world-wide or local, is conveyed to our consumers well before traditional and existing media sources. An analysis of international events worldwide during 2018 determined that EVNTL's clients were aware of events transpiring over 25 minutes before the next closest information source. The unparalleled delivery of CENS intelligence will eneable you to react appropriately to unplanned and unpredictable events at home and abroad. CENS enables clients to respond immediately to protect critical infrastructure, assets and your most valuable resource - people.</p>
        <p>From newsworthy events to breaking sports news, you will consistently receive actionable information, delivered first, to enable you to make the best decisions to advance your interest.</p>
      </div>
    </section>
  </div>
</template>

<script>
import EvntlLogo from '@/assets/hgDiscover/logo-full.svg';

export default {
  name: 'DiscoverPage',
  data() {
    return {
      image: EvntlLogo
    }
  },
}
</script>

<style scoped>
@media (max-width: 900px) {
  .discoverContainer {
    position: relative;
    background: #1e1e1e;
    height: auto;
    width: 100%;
    display: grid;
    grid-template-rows: 1fr 3fr;
    grid-gap: 2rem 5rem;
  }
  .discoverProjects {
    padding: 5rem 2rem;
    height: auto;
    color: white;
  }
  .discoverProjects > h1 {
    color: white;
    font-size: 5vw;
    padding: 1rem;
    border-style: none none solid none;
    border-color: white;
  }
  .discoverEvntl {
    padding: 0rem 2rem;
  }
  .discoverEvntl > img {
    height: auto;
    width: 70%;
  }
  .discoverEvntl p {
    color: white;
  }
}
@media (min-width: 900px) {
  .discoverSection {
    position: relative;
    background: url('../../assets/circuit.png') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;    
    -o-background-size: cover;      
    background-size: cover;
  }
  .tinter {
    background: #1e1e1e;
    position: absolute;
    opacity: 0.9;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
  .discoverContainer {
    position: relative;
    height: auto;
    width: 100%;
    display: grid;
    grid-template-rows: 1fr 3fr;
    grid-gap: 2rem 5rem;
  }
  .discoverProjects {
    padding: 5rem 10rem;
    height: auto;
    color: white;
  }
  .discoverProjects > h1 {
    color: white;
    font-size: 2vw;
    padding: 1rem;
    border-style: none none solid none;
    border-color: white;
  }
  .discoverEvntl {
    padding: 0rem 10rem;
  }
  .discoverEvntl > img {
    height: auto;
    width: 50%;
  }
  .discoverEvntl p {
    color: white;
  }
}

</style>
